'use client';

import { useAuth, useOrganization, useUser } from '@clerk/nextjs';
import posthog from 'posthog-js';
import { useEffect } from 'react';

// Attaches tenant context to PostHog events so captured errors carry who/where.
// distinct_id = stable Clerk userId; org via group analytics. reset() on logout
// only — prevents a shared browser merging two users' identities/replays.
export const PostHogIdentify = () => {
  const { isSignedIn, userId } = useAuth();
  const { user } = useUser();
  const { organization } = useOrganization();

  // Depend on primitives, not Clerk's fresh-every-render object refs, so the
  // effect only re-runs on real identity/org changes.
  const email = user?.primaryEmailAddress?.emailAddress;
  const name = user?.fullName ?? undefined;
  const orgId = organization?.id;
  const orgName = organization?.name;
  const orgSlug = organization?.slug;

  useEffect(() => {
    if (!isSignedIn || !userId) {
      if (isSignedIn === false) posthog.reset();
      return;
    }

    posthog.identify(userId, { email, name });

    if (orgId) {
      posthog.group('organization', orgId, { name: orgName, slug: orgSlug });
    } else {
      // Mid org-switch Clerk briefly reports no active org. Clear the previous
      // org group so errors/replays captured in that window (the org-switch crash
      // this integration exists to observe) aren't mis-attributed to the old org.
      posthog.resetGroups();
    }
  }, [isSignedIn, userId, email, name, orgId, orgName, orgSlug]);

  return null;
};
